export const EDUCATION = [
  {
    institution: 'Full Cycle',
    course: 'Pós-graduação em Arquitetura de Software e Microsserviços',
    period: 'set. de 2024 – set. de 2026',
  },
  {
    institution: 'UNINTER',
    course: 'Tecnólogo em Gestão da Segurança e Defesa Cibernética',
    period: 'mar. de 2025 – mar. de 2027 (em andamento)',
  },
  {
    institution: 'Impacta Tecnologia',
    course: 'Tecnólogo em Engenharia de Software',
    period: 'jan. de 2007 – dez. de 2009',
  },
  {
    institution: 'Rocketseat',
    course: 'Formação em Desenvolvimento Full Stack',
    period: 'jan. de 2020 – dez. de 2024',
  },
  {
    institution: 'Origamid',
    course: 'Formação em Desenvolvimento Front-end',
    period: 'jan. de 2012 – dez. de 2020',
  },
];
